import { createSoftLoginService, SoftLoginService } from '../application/services/SoftLoginService';
import { ShopfloSoftLoginAdapter } from '../infra/adapters/shopflo.adapter';

let softLoginServiceInstance: SoftLoginService | null = null;

export function getSoftLoginService(): SoftLoginService {
  if (!softLoginServiceInstance) {
    softLoginServiceInstance = createSoftLoginService([new ShopfloSoftLoginAdapter()]);
  }
  return softLoginServiceInstance;
}
